import React from 'react';
import { createPortal } from 'react-dom';
import { X, Calendar, Clock, FileText, User } from 'lucide-react';

export default function OrdenesExtrasModal({ tecnico, onClose, onVerOrden }) {
  if (!tecnico) return null;

  const formatearHoras = (minutos) => {
    if (!minutos) return '0:00';
    const horas = Math.floor(minutos / 60);
    const mins = Math.round(minutos % 60);
    return `${horas}:${mins.toString().padStart(2, '0')}`;
  };

  const formatearFecha = (fechaStr) => {
    if (!fechaStr) return '-';
    try {
      return new Date(fechaStr).toLocaleDateString('es-ES', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (e) {
      return fechaStr;
    }
  };

  return createPortal(
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999] p-4 animate-in fade-in duration-200">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col overflow-hidden animate-in zoom-in-95 duration-200">
        
        {/* Header */}
        <div className="p-6 border-b border-gray-100 flex justify-between items-start bg-gray-50/50">
          <div>
            <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2">
              <Clock className="w-6 h-6 text-red-600" />
              Detalle de Horas Extras
            </h2>
            <div className="mt-2 flex items-center gap-2 text-gray-600">
              <User className="w-4 h-4" />
              <span className="font-medium">{tecnico.nombre}</span>
              <span className="text-gray-300">|</span>
              <span className="bg-red-50 text-red-700 px-2 py-0.5 rounded-full text-xs font-bold border border-red-100">
                +{formatearHoras(tecnico.minutos_extras)} horas total
              </span>
            </div>
          </div>
          <button 
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-400 hover:text-gray-600"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto p-0">
          {tecnico.lista_ordenes && tecnico.lista_ordenes.length > 0 ? (
            <table className="w-full text-left border-collapse">
              <thead className="bg-gray-50 sticky top-0 z-10">
                <tr>
                  <th className="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider border-b border-gray-100">Orden</th>
                  <th className="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider border-b border-gray-100">Fecha</th>
                  <th className="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider border-b border-gray-100">Cliente</th>
                  <th className="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider border-b border-gray-100 text-right">Extras</th>
                  <th className="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider border-b border-gray-100"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {tecnico.lista_ordenes.map((orden, idx) => (
                  <tr 
                    key={idx} 
                    className="hover:bg-emerald-50/50 transition-colors group cursor-pointer"
                    onClick={() => onVerOrden && onVerOrden(orden)}
                  >
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2 font-medium text-gray-900">
                        <FileText className="w-4 h-4 text-gray-400 group-hover:text-emerald-500" />
                        {orden.numero}
                      </div>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-500">
                      {formatearFecha(orden.fecha)}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600">
                      {orden.cliente}
                    </td>
                    <td className="px-6 py-4 text-right">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-100">
                        +{formatearHoras(orden.minutos)}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-right">
                      <button className="text-xs text-emerald-600 hover:text-emerald-800 font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                        Ver detalle
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="p-12 text-center text-gray-500">
              <p>No hay detalles de órdenes disponibles.</p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-gray-100 bg-gray-50 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium text-sm shadow-sm transition-all"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
